import {useEffect, useState} from "react";
import Theme from "../utils/CheckTheme";
import {FiMoon, FiSun} from "react-icons/fi";

export default function ThemeToggler(props) {
  const [theme, setTheme] = useState(Theme() || "dark")
  const element = document.documentElement

  useEffect(() => {
    switch (theme) {
      case 'dark':
        element.classList.add('dark')
        break
      case 'light':
        element.classList.remove('dark')
        break
      default:
        break
    }
    localStorage.setItem('theme', theme)
    props.parentCallback(theme);
    window.scrollBy(0, 1)
  }, [props, element, theme])

  return (
      <button
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          className='themeToggler hoverLink drop-shadow-lg border-4 border-amber-400 opacity-40 hover:opacity-100 duration-200 text-nfr-color-100 bg-nfr-color-800 p-2 rounded-full shadow-2xl dark:text-nfr-color-900 dark:bg-nfr-color-100'
      >
        {theme === 'dark' ? <FiSun className={'text-2xl'}/> : <FiMoon className={'text-2xl'}/>}
      </button>
  )
}
